import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
  name: 'mascaraTelefone'
})
export class TelefonePipe implements PipeTransform {
  strFormatada: string;

  transform(str: string) {
    if (str) {
      if (str.length === 10) {
        this.strFormatada = '('.concat(str.substring(0, 2)).concat(') ').concat(str.substring(2, 6))
          .concat('-').concat(str.substring(6, 10));
      } else if (str.length === 11) {
        this.strFormatada = '('.concat(str.substring(0, 2)).concat(') ')
          .concat(str.substring(2, 3))
          .concat(' ').concat(str.substring(3, 7))
          .concat('-').concat(str.substring(7, 11));
      } else {
        // FORMATO DESCONHECIDO, RETORNAR A STRING SEM FORMATAR
        this.strFormatada = str;
      }
    }

    return this.strFormatada;
  }
}



// WEBPACK FOOTER //
// ./src/app/pipes/mascara-telefone.pipe.ts